export function parseNumber(value: string | null) {
  return value ? parseInt(value, 10) || undefined : undefined;
}
